import React, { MouseEventHandler } from 'react';
import { TabDefinition } from '@kizi/shared-components';
import {
  PriceMode,
  CostTab,
  PackageComp,
  ProductProsCons,
  Testoordel,
  SwitchTab3P,
} from '@kizi/comparator-components';
import {
  IProduct,
  ProductWrapper,
  TriplePlayProductSupplier,
} from '@kizi/comparator-core';
import { Div, List, ListItem, P } from '@kizi/core-components';

interface ITriplePlayTabs {
  data: IProduct;
  priceMode: PriceMode;
  setModalTab0: MouseEventHandler;
  setModalTab1: MouseEventHandler;
  setModalTab2: MouseEventHandler;
  setModalTab3: MouseEventHandler;
}

export function getTabs({
  data,
  setModalTab0,
}: ITriplePlayTabs): TabDefinition[] {
  const { provider, prosAndCons } = data;
  const isArrayOfProsAndCons = Array.isArray(prosAndCons);
  const _prosAndCons = isArrayOfProsAndCons ? prosAndCons[0] : prosAndCons;
  const { description, label } = provider;

  return [
    {
      label: 'Over aanbieder',
      content: (
        <Div
          display={[null, null, 'flex']}
          flexDirection={['column', 'column', 'row']}
        >
          <Div>
            <List variant="accordionProductInner">
              <ListItem>
                <Div variant="detailsListHeading">
                  <P variant="bodyImportant">{label}</P>
                </Div>
                <p>{description}</p>
              </ListItem>
              <ListItem>
                <ProductProsCons {..._prosAndCons} />
              </ListItem>
            </List>
          </Div>
          <Testoordel scoreInput={data?.scoreEntity} />
        </Div>
      ),
    },
    {
      label: 'Kosten & contract',
      content: <CostTab data={data} />,
    },
    {
      label: 'Pakket',
      content: (
        <PackageComp
          product={data as unknown as ProductWrapper}
          length={5}
          onButtonInfoClick={setModalTab0}
        />
      ),
    },
    {
      label: 'Over je aanvraag',
      content: (
        <SwitchTab3P
          supplier={data.provider as unknown as TriplePlayProductSupplier}
        />
      ),
    },
  ];
}
